// app-page-whatwedo.js
// fn_reveal_scroll

var fn_reveal_scroll = function () {

  //
  // > We Test if page is QFN and if it is IE or not
  //
  if ( $('body.path-nos-missions').length && $('html:not(.ie)').length ) {
    //
    //
    // JS babelized
    var ratio = 0.1,
        options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.75
    },
        handleIntersect = function handleIntersect(t, s) {
      t.forEach(function (t) {
        t.intersectionRatio > 0.1 && (t.target.classList.add("reveal"), s.unobserve(t.target));
      });
    },
        observer = new IntersectionObserver(handleIntersect, options);

    document.querySelectorAll('[class^="mission__step"]').forEach(function (t) {
      observer.observe(t);
    });
    // //
  }

  if ( $('body.path-nos-missions').length && $('html.ie').length ) {
    //
    //
    $('.mission__step').addClass('reveal');
    // //
  }

};
